import { render, staticRenderFns } from "./pago.vue?vue&type=template&id=781058a4&scoped=true&"
import script from "./pago.vue?vue&type=script&lang=js&"
export * from "./pago.vue?vue&type=script&lang=js&"
import style0 from "./pago.vue?vue&type=style&index=0&id=781058a4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781058a4",
  null
  
)

export default component.exports